
import { butter } from "~/plugins/buttercms";
export default {
  props: ["deliveryDate"],
  async created() {
    // TODO refactor the code
    // let self = this;
    // let isProductPage = !!this.$route.params["sku"]
    // window.addEventListener('click', function(e){
    //   if (!self.$el.contains(e.target)){
    //     if (e.target.classList.contains('date-picker-days-button') && isProductPage ) {
    //       self.isshowDropDown = true;
    //     } else {
    //       self.isshowDropDown = false;
    //     }
    //   }
    // });

    let self = this;
    window.addEventListener("click", function (e) {
      if (
        !self.$el.contains(e.target) &&
        !(e.target.id === "add_to_basket_btn")
      ) {
        self.isshowDropDown = false;
      }
    });

    this.disableOccasion = !this.deliveryDate;
    await this.getOccasionsList();
    if(this.occasion && this.occasion !== ''){
        this.$nuxt.$emit("occasionSelected", this.occasion);
    }

    // // add specific logic for product page to open occations in default empty date
    // if ( isProductPage && this.deliveryDate &&  this.occasion==='') {
    //   this.isshowDropDown = true;
    //   this.isDropdownOpenMobile=true;
    //   this.showSlideOver = true;
    //   // check the device (tailwind sm - 640px)
    //       if (window.innerWidth < 640) {
    //         this.toggleBodyScrolling();
    //       }
    // }
  },
  mounted() {
    this.$nuxt.$on("toggleOccasionSelector", (device) => {
      this.toggleIsShowDropDown(device);
    });
  },
  data() {
    return {
      occasion: sessionStorage.occasion || "",
      occasionsHeader: {},
      occasions: [],
      disableOccasion: true,
      showSlideOver: false,
      isDropdownOpenMobile: false,
      isshowDropDown: false,
      disableSaveButton:
        sessionStorage.occasion == null || sessionStorage.occasion == ""
          ? true
          : false,
    };
  },
  watch: {
    deliveryDate() {
      if (this.deliveryDate) {
        this.disableOccasion = !this.deliveryDate;
        if (this.$route.params["sku"] && this.occasion === "") {
          this.sleep(300).then(() => {
            //Sleeping to replicate the delay in loading the date picker for consistency purposes
            this.isshowDropDown = true;
            this.isDropdownOpenMobile = true;
            this.showSlideOver = true;
          });
        }
      }
    },
    occasion() {
      this.disableSaveButton =
        this.occasion == null || this.occasion == "" ? true : false;
    },
  },
  computed: {
    isMobile() {
      return window.matchMedia("(max-width: 768px)").matches;
    },
  },
  methods: {
    selectOptionDesktop(occasion) {
      this.occasion = occasion;
      this.save();
    },
    selectOptionMobile(occasion) {
      this.occasion = occasion;
      this.save();
    },
    save() {
      sessionStorage.occasion = this.occasion;
      this.$emit("select-occasion", this.occasion);
      this.$nuxt.$emit("occasionSelected", this.occasion);
      this.$store.dispatch("cartItem/SET_OCCASION", this.occasion);
      if (!this.isMobile){
        this.isshowDropDown = false;
        this.isDropdownOpenMobile=false;
        this.showSlideOver = false;
      }
      this.toggleBodyScrolling();
    },
    toggleIsShowDropDown(device) {
      // TODO refactor the code
      const ele = document.getElementById("date_selector");
      if (ele !== null) {
        return;
      }
      if (!this.disableOccasion) {
        this.isshowDropDown = !this.isshowDropDown;
        this.showSlideOver = true;
        this.isDropdownOpenMobile = true;
        if (device === "mobile") {
          this.toggleBodyScrolling();
        }
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async getOccasionsList() {
      try {
        const response = await butter(this.$config).content.retrieve(
          ["occasions"],
          { locale: this.$i18n.locale, timeout: 10000 }
        );

        this.occasionsHeader =
          response?.data.data["occasions"][0]["occasion-header"];
        this.occasions = response?.data.data["occasions"][0]["occasion-types"];
        this.occasions = this.occasions.map(
          (occasion) => occasion["occasion-name"]
        );
        if (this.$route.params.occasion) {
          this.occasions.forEach((item) => {
            if (
              item.replace(/[-\s]/g, "").toLowerCase() ===
              this.$route.params.occasion.replace(/-/g, "").toLowerCase()
            ) {
              this.occasion = item;
              return;
            }
          });
          sessionStorage.occasion = this.occasion;
        }
        this.occasion = sessionStorage.occasion || this.occasion;
      } catch (error) {
        console.error(error);
      }
    },
    closeSlideOver() {
      this.isshowDropDown = false;
      this.showSlideOver = false;
      this.isDropdownOpenMobile = false;
      this.toggleBodyScrolling();
    },
    toggleBodyScrolling() {
      let body = document.body;
      body.style.overflow = !this.isshowDropDown ? "auto" : "hidden";
    },
  },
};
